import { queryOptions } from "@tanstack/react-query";
import { getPlatformSettings } from "api-client";

export function platformSettingsQueryOptions() {
  return queryOptions({
    queryKey: ["platform-settings"],
    queryFn: async () => {
      const response = await getPlatformSettings();
      return response.data.data;
    },
  });
}
